var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.randomId}},[_c('ejs-listview',{ref:"listNe",attrs:{"id":"flat-list","dataSource":_vm.data,"filterCode":_vm.typeCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }